import React from 'react';
import Chart from 'chart.js';
import { Grid } from '@material-ui/core';
import { defaultGraphConfig } from 'utils/graphs';
import i18n from 'i18n';

interface BarGraphProps {
  values: any;
}

const BarGraph = ({ values }: BarGraphProps) => {
  const containerRef = React.useRef<HTMLCanvasElement>(null);

  const config = defaultGraphConfig(
    {
      labels: values.map(item => i18n.t(item.label)),
      datasets: [
        {
          data: values.map(item => item.count),
          backgroundColor: values.map(item => item.color),
          hoverBackgroundColor: values.map(item => item.color),
          borderColor: values.map(item => item.color),
          borderWidth: 0.7,
          hoverOffset: 80,
        },
      ],
    },
    false,
    undefined,
    undefined,
    'bar',
    20
  );

  config.options.scales.xAxes[0].ticks.display = true;
  config.options.scales.xAxes[0].gridLines.display = false;
  config.options.scales.yAxes[0].ticks.display = true;
  config.options.scales.yAxes[0].ticks.beginAtZero = true;

  React.useEffect(() => {
    let chart;

    if (containerRef.current) {
      chart = new Chart(containerRef.current, config);
    }
    return () => chart?.destroy();
  }, [containerRef, config]);

  return (
    <Grid container>
      <canvas ref={containerRef} width="auto" height="auto"></canvas>
    </Grid>
  );
};

export default BarGraph;
